import React from 'react';
import styles from './ApprovalPending.module.scss';
import { ReactComponent as PendingApproval } from "@/assets/icons/PendingApproval.svg";
import { useTranslation } from 'react-i18next';

interface ApprovalPendingProps {
    onClose: () => void;
  }

export const ApprovalPendingCard: React.FC<ApprovalPendingProps> = ({ onClose }) => {
    const { t } = useTranslation();
    return (
        <div className={styles.cardContainer}>
            <div className={styles.logoContainer}><PendingApproval /></div>
            <h2 className={styles.text}>{t('approval_pending')}</h2>
            <p className={styles.subText}>
                {t('approval_pending_msg')}
            </p>
            <button className={styles.button} onClick={onClose}>
                {t('close')}
            </button>
        </div>
    );
}
